module.exports = __webpack_public_path__ + "img/contractManagement.333c460f.svg";